import * as React from 'react'

import { NextPage } from '@grandvisionhq/next'
import {
  ErrorCase,
  InitialProps,
  Page,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail/sunglasses'

import { composePDP } from '../../../components/hocs/compose-pdp'

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => <Page {...props} />

ProductDetailPage.getInitialProps = Page.getInitialProps

export default composePDP<Props>(ProductDetailPage)
